
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAbstractAutomationButtonSquared as ObcAbstractAutomationButtonSquaredElement} from '@oicl/openbridge-webcomponents/dist/automation/automation-button/abstract-automation-button-squared.js';
 
 
 

 
 export const ObcAbstractAutomationButtonSquared = createComponent({
   react: React,
   tagName: 'undefined',
   elementClass: ObcAbstractAutomationButtonSquaredElement,
   events: {
     
   }
  });
 
 